@if (componentType() === componentTypes.product) {
<app-product></app-product>
} @else if(componentType() === componentTypes.shop) {
<app-shop></app-shop>
} @else {
Loading...
}